/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetFamilyMemberNotificationsPathParameters } from 'api/actions/get-family-member-notifications/get-family-member-notifications-path-parameters';
import { GetFamilyMemberNotificationsResponse } from 'api/actions/get-family-member-notifications/get-family-member-notifications-response';

type GetFamilyMemberNotificationsQueryParameters = Record<string, any>;

/**
 * The path of the GetFamilyMemberNotifications action.
 */
export const getFamilyMemberNotificationsActionPath = new SweetPath<keyof GetFamilyMemberNotificationsPathParameters>(
  '/user/family/members/{userId}/notifications',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetFamilyMemberNotifications actions.
 */
export default function createGetFamilyMemberNotificationsAction(axios: AxiosInstance) {
  return function getFamilyMemberNotificationsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetFamilyMemberNotificationsPathParameters;
    query?: GetFamilyMemberNotificationsQueryParameters;
  }) {
    const path = getFamilyMemberNotificationsActionPath.insert(parameters);

    return axios.get<GetFamilyMemberNotificationsResponse, GetFamilyMemberNotificationsResponse>(path, {
      params: query,
      headers,
    });
  };
}
